"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter } from "next/navigation";
import { useReCaptcha } from "next-recaptcha-v3";
import { useState } from "react";
import { postConsent } from "@/app/[domain]/(sites)/_actions/permission/post-consent";
import { submitNewsletterSubscription } from "@/components/Newsletter/NewsletterSignUp/_actions/submit-newsletter-subscription";
import { usePermission } from "@/contexts/permission/permission.context";
import { useSite } from "@/contexts/site/site.context";
import { captureClientMessage } from "@/services/logging/capture-client-message";
import type { Fetchable } from "@/services/utilities/fetchable";
import { failed, hasFailed, initial, pending, succeeded } from "@/services/utilities/fetchable";
export function useNewsletterSignup(t0) {
  const $ = _c(12);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? initial() : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const initialState = t1;
  const {
    refresh
  } = useRouter();
  const pathname = usePathname();
  const {
    executeRecaptcha
  } = useReCaptcha();
  const {
    domain
  } = useSite();
  const permissionText = usePermission();
  const [submissionState, setSubmissionState] = useState(initialState);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function reset() {
      setSubmissionState(initial());
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const reset = t2;
  let t3;
  if ($[3] !== domain || $[4] !== executeRecaptcha || $[5] !== pathname || $[6] !== refresh) {
    t3 = async (email, isTermsAccepted, honeypotValue) => {
      setSubmissionState(pending());
      if (honeypotValue) {
        captureClientMessage("Honeypot field was filled out, likely a bot submission.", {
          extra: {
            domain,
            honeypotValue
          }
        });
        setSubmissionState(succeeded());
        return;
      }
      const recaptchaToken = await executeRecaptcha(`${domain.replace(".", "_")}_newsletter_signup`);
      if (!recaptchaToken) {
        setSubmissionState(failed("No reCAPTCHA token received."));
        return;
      }
      const postConsentResponse = await postConsent(email, isTermsAccepted, pathname);
      if (hasFailed(postConsentResponse)) {
        setSubmissionState(postConsentResponse);
        return;
      }
      const submitNewsletterSubscriptionResponse = await submitNewsletterSubscription({
        email,
        hasMarketingConsent: isTermsAccepted,
        recaptchaToken
      });
      setSubmissionState(submitNewsletterSubscriptionResponse);
      refresh();
    };
    $[3] = domain;
    $[4] = executeRecaptcha;
    $[5] = pathname;
    $[6] = refresh;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const submit = t3;
  let t4;
  if ($[8] !== permissionText || $[9] !== submissionState || $[10] !== submit) {
    t4 = {
      permissionText,
      reset,
      submissionState,
      submit
    };
    $[8] = permissionText;
    $[9] = submissionState;
    $[10] = submit;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}